import fetchPonyfill from 'fetch-ponyfill';

export const {fetch} = fetchPonyfill();

export const ActionTypes = {
    LOAD_CAPTIONS_MANIFEST: 'LOAD_CAPTIONS_MANIFEST',
    PARSE_CAPTIONS_MANIFEST: 'PARSE_CAPTIONS_MANIFEST',
    CAPTIONS_MANIFEST_LOADED: 'CAPTIONS_MANIFEST_LOADED',
    CAPTIONS_MANIFEST_FAILED: 'CAPTIONS_MANIFEST_FAILED',
};

export const loadingManifest = () => ({
    type: ActionTypes.LOAD_CAPTIONS_MANIFEST,
});

export const manifestLoaded = () => ({
    type: ActionTypes.CAPTIONS_MANIFEST_LOADED,
});

export const manifestFailed = () => ({
    type: ActionTypes.CAPTIONS_MANIFEST_FAILED,
});

export const parseManifest = (urls) => ({
    type: ActionTypes.PARSE_CAPTIONS_MANIFEST,
    urls,
});

export const loadManifest = () => async (dispatch, getState) => {
    const {config} = getState();

    try {
        dispatch(loadingManifest());
        const manifest = config.get('captionsManifest');

        dispatch(parseManifest(manifest));
        dispatch(manifestLoaded());

        return manifest;
    } catch (error) {
        dispatch(manifestFailed());
        console.error(error); // eslint-disable-line no-console
        throw new Error('Manifest failed to load');
    }
};



// WEBPACK FOOTER //
// ./scripts/store/captions/actions.js